module.exports = __webpack_public_path__ + "png/quick-registration-coin-2.png?ba39a283c27df85ff917bfced3ca8914";